import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { name: '热血漫画', path: '/category/rexue' },
      { name: '玄幻漫画', path: '/category/xuanhuan' },
      { name: '恋爱漫画', path: '/category/aiqing' },
      { name: '科幻漫画', path: '/category/kehuan' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { name: '排行榜', path: '/#ranking' },
      { name: '最新更新', path: '/#latest' },
      { name: '热门推荐', path: '/#hot' },
      { name: '分类浏览', path: '/category/rexue' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '用户口碑', path: '/about#reputation' },
      { name: '联系方式', path: '/about#contact' },
      { name: '常见问题', path: '/about#faq' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: '漫画之家', path: '#', external: true },
      { name: '动漫星空', path: '#', external: true },
      { name: '二次元社区', path: '#', external: true },
      { name: 'ACG资源站', path: '#', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-14">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-lg text-background-50 mb-3 pb-3 border-b border-background-700/50">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    {link.external ? (
                      <a
                        href={link.path}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-sm text-background-400 hover:text-background-100 transition-colors"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-700/50 gap-6">
          <div className="flex flex-col items-center sm:items-start">
            <Link to="/" className="flex items-center gap-3 group mb-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-2xl font-bold text-background-50 leading-none">
                哔咔漫画
              </span>
            </Link>
            <p className="text-xs text-background-500">
              免费漫画大全 — 热门漫画在线阅读平台
            </p>
          </div>

          <div className="flex flex-col items-center sm:items-end gap-2">
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
            <p className="text-xs text-background-500">
              &copy; 2026 哔咔漫画网 — 保留所有权利
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}